import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromContent from './content.reducer';
import * as StationState from '@station/_ngrx/station.selectors'
import { ContentDto } from '@api/rest';

export const selectContentState = createFeatureSelector<fromContent.State>(
  fromContent.contentsFeatureKey
);

export const getContents = createSelector(selectContentState, fromContent.selectAll);
export const getContentsDict = createSelector(selectContentState, fromContent.selectEntities);
export const getSelectedId = createSelector(selectContentState, state => state.selected);

export const getSelected = createSelector(
  getContentsDict,
  getSelectedId,
  (contents, id): ContentDto => contents[ id ]
);

export const getStationContents = createSelector(
  getContentsDict,
  StationState.getSelected,
  (
    dict,
    station
  ): ContentDto[] => station?.content_refs?.map(ref => dict[ ref ]).filter(Boolean) || []
);
